import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.string.includes.js";
import Details from './components/details';
import List from './components/list';
import { getReceiversList, removeReceiver } from "@api/correspondence/object";
import { mapState } from "vuex";
export default {
  name: "correspondence-object",
  props: {
    id: {
      default: function _default() {
        return undefined;
      }
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState('cpscc', ['userInfo'])), {}, {
    isCpscAdmin: function isCpscAdmin() {
      if (this.userInfo && this.userInfo.data2) {
        if (Array.isArray(this.userInfo.data2.roles)) {
          return this.userInfo.data2.roles.includes('函证中心管理员');
        }
      }
      return false;
    },
    searchQuery: function searchQuery() {
      var search = this.searchKey !== '' && this.searchKey !== undefined ? "c03CusName.contains(\"".concat(this.searchKey, "\")") : undefined;
      var params = "";
      if (search) {
        params = search;
        if (!this.listFilterKey) {
          params = "".concat(search, " && c03CorrectAddress == \"").concat(this.listFilterKey, "\"");
        }
      } else if (!this.listFilterKey) {
        params = "c03CorrectAddress == \"".concat(this.listFilterKey, "\"");
      }
      return params;
    }
  }),
  data: function data() {
    return {
      searchKey: '',
      listFilterKey: 'all',
      filterData: [{
        name: '所有',
        value: 'all'
      }, {
        name: '未核验',
        value: ''
      }],
      dataList: [],
      template: null,
      loading: false,
      totalPages: 0,
      currentPage: 1,
      pageSize: 10,
      sortBy: undefined
    };
  },
  methods: {
    getFilter: function getFilter(item) {
      this.listFilterKey = item.value;
      this.getList();
    },
    remove: function remove(id) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$_this$$awaitTo, _yield$_this$$awaitTo2, err, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _this.$$confirm('确定删除?');
            case 1:
              _this.loading = true;
              _context.n = 2;
              return _this.$awaitTo(removeReceiver(id));
            case 2:
              _yield$_this$$awaitTo = _context.v;
              _yield$_this$$awaitTo2 = _slicedToArray(_yield$_this$$awaitTo, 2);
              err = _yield$_this$$awaitTo2[0];
              res = _yield$_this$$awaitTo2[1];
              _this.loading = false;
              if (!err) {
                _context.n = 3;
                break;
              }
              return _context.a(2);
            case 3:
              _this.$message.success('操作成功');
              _this.getList();
            case 4:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    sortChange: function sortChange(_ref) {
      var prop = _ref.prop,
        order = _ref.order;
      var type = {
        descending: 'desc',
        ascending: 'asc'
      };
      if (type[order]) {
        this.sortBy = "".concat(prop, " ").concat(type[order]);
      } else {
        this.sortBy = undefined;
      }
      this.handleCurrentChange(1);
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.getList();
    },
    getList: function getList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _yield$_this2$$awaitT, _yield$_this2$$awaitT2, err, res, headers, data, pagination;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this2.loading = true;
              _context2.n = 1;
              return _this2.$awaitTo(getReceiversList({
                PageNumber: _this2.currentPage,
                PageSize: _this2.pageSize,
                SortBy: _this2.sortBy,
                SearchQuery: _this2.searchQuery
              }));
            case 1:
              _yield$_this2$$awaitT = _context2.v;
              _yield$_this2$$awaitT2 = _slicedToArray(_yield$_this2$$awaitT, 2);
              err = _yield$_this2$$awaitT2[0];
              res = _yield$_this2$$awaitT2[1];
              _this2.loading = false;
              if (!err) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              headers = res.headers, data = res.data;
              if (Array.isArray(data)) {
                _this2.dataList = data;
              }
              pagination = headers['x-pagination'];
              if (pagination) {
                _this2.totalPages = JSON.parse(pagination).totalCount;
              }
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    view: function view(item) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _yield$_this3$$awaitT, _yield$_this3$$awaitT2, err, data;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.$awaitTo(_this3.$dialog(List, {
                dialog: {
                  title: '适配作业数'
                },
                props: {}
              }, function (template) {
                _this3.template = template;
              }));
            case 1:
              _yield$_this3$$awaitT = _context3.v;
              _yield$_this3$$awaitT2 = _slicedToArray(_yield$_this3$$awaitT, 2);
              err = _yield$_this3$$awaitT2[0];
              data = _yield$_this3$$awaitT2[1];
              _this3.template = null;
              if (!err) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2);
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    edit: function edit(type, item) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var isEdit, title, _yield$_this4$$awaitT, _yield$_this4$$awaitT2, err, data;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              isEdit = type === 'edit';
              title = {
                edit: '编辑',
                create: '新建',
                view: '查看',
                'check': '核验'
              };
              _context4.n = 1;
              return _this4.$awaitTo(_this4.$dialog(Details, {
                dialog: {
                  title: title[type],
                  width: '1100px'
                },
                props: {
                  id: item ? item.c03Id : undefined,
                  readOnly: type === 'view',
                  type: type
                }
              }, function (template) {
                _this4.template = template;
              }));
            case 1:
              _yield$_this4$$awaitT = _context4.v;
              _yield$_this4$$awaitT2 = _slicedToArray(_yield$_this4$$awaitT, 2);
              err = _yield$_this4$$awaitT2[0];
              data = _yield$_this4$$awaitT2[1];
              _this4.template = null;
              if (!err) {
                _context4.n = 2;
                break;
              }
              return _context4.a(2);
            case 2:
              _this4.getList();
            case 3:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    }
  },
  created: function created() {
    this.getList();
  }
};